import { useOnboardingShallowStore } from '@frontend/product-onboarding';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { CALL_INTEL_PRO_ONBOARDING_HOTSPOT_KEYS } from '../constant';
import type { TaskAction, TaskActionArgs } from '../types';

export function useProAssignUserRolesAction({ onClose }: TaskActionArgs): TaskAction {
  const { navigate } = useSettingsNavigate();

  const { completeHotspot } = useOnboardingShallowStore('completeHotspot');

  return {
    isEnabled: true,
    onSelect: () => {
      completeHotspot(CALL_INTEL_PRO_ONBOARDING_HOTSPOT_KEYS.TOP_BAR_SETTINGS_ICON);
      completeHotspot(CALL_INTEL_PRO_ONBOARDING_HOTSPOT_KEYS.SETTINGS_PAGE_USER_MANAGEMENT_GROUP);
      navigate({ to: '/organization/users' });
      onClose();
    },
  };
}
